import styles from './ProductDetails.module.scss';

export default function DetailsExtraInfo({ productDetails }) {
  if (
    productDetails.ingredients ||
    productDetails.instructions ||
    productDetails.supplierInfo ||
    productDetails.madeIn ||
    productDetails.allergens
  ) {
    return (
      <div className={styles.productDesciption}>
        {productDetails.ingredients && (
          <>
            <p className={styles.desciptionTitle}>Συστατικά</p>
            <p className={styles.desciptionTextMargin}>{productDetails.ingredients}</p>
          </>
        )}
        {productDetails.allergens && (
          <>
            <p className={styles.desciptionTitle}>Αλλεργιογόνα</p>
            <p className={styles.desciptionTextMargin}>{productDetails.allergens}</p>
          </>
        )}
        {productDetails.instructions && (
          <>
            <p className={styles.desciptionTitle}>Οδηγίες Χρήσης/Αποθήκευσης</p>
            <p className={styles.desciptionTextMargin}>{productDetails.instructions}</p>
          </>
        )}
        {productDetails.supplierInfo && (
          <>
            <p className={styles.desciptionTitle}>Πληροφορίες Προμηθεύτη</p>
            <p className={styles.desciptionTextMargin}>{productDetails.supplierInfo}</p>
          </>
        )}
        {productDetails.madeIn && (
          <>
            <p className={styles.desciptionTitle}>Χώρα Παραγωγής</p>
            <p className={styles.desciptionTextMargin}>{productDetails.madeIn}</p>
          </>
        )}
      </div>
    );
  }
  return null;
}
